<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card :loading="loading" :disabled="loading">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title>Notifications</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-data-table
                    :items="notifications"
                    :headers="headers"
                  >
                    <template #[`item.created_at`]="{ item }">
                      {{ item.created_at | formatDate }}
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <v-btn v-if="!item.read_at" icon small @click="doMarkAsRead(item)">
                        <v-icon small>mdi-check</v-icon>
                      </v-btn>
                      <v-btn icon small @click="open(item)">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex'
export default {
  data: () => ({
    headers:[
      {text:'Type', value:'data.title'},
      {text:'Message', value:'data.message'},
      {text:'Date', value:'created_at'},
      {text:'Actions', value:'actions'},
    ]
  }),
  computed:{
    ...mapGetters('notifications', ['notifications', 'loading'])
  },
  mounted () {
    this.fetchNotifications()
  },
  methods: {
    ...mapActions('notifications', {
      fetchNotifications: 'index',
      markAsRead: 'markAsRead'
    }),
    doMarkAsRead(notification) {
      this.markAsRead(notification.id)
        .then(() => {
          this.fetchNotifications()
        })
    },
    open(notification){
      if(!notification.read_at){
        this.markAsRead(notification.id);
      } 
      this.$router.push(notification.data.url)
    }
  },
  filters:{
    formatDate (value) {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY, HH:mm:ss');
    }
  },
}
</script>

<style>

</style>